import apiClient from './apiClient';
import { API_URL } from '../config';

export interface ValidationIssue {
  rule_id: string;
  severity: 'info' | 'warning' | 'critical';
  message: string;
  details: string;
  field: string;
}

export interface PatientExamValidationRequest {
  patient_gender?: string | null;
  patient_age?: number | null;
  patient_dob?: string | null;
  cpt_code?: string | null;
  exam_name?: string | null;
  modality?: string | null;
  body_part?: string | null;
  contrast?: string | null;
  laterality?: string | null;
  trigger?: string;
  dictation_text?: string | null;
  use_llm?: boolean;
}

export interface PatientExamValidationResponse {
  valid: boolean;
  issues: ValidationIssue[];
  trigger: string;
  validated_at: string;
  duration_ms: number;
  used_llm: boolean;
}

const validatePatientExam = async (
  request: PatientExamValidationRequest,
): Promise<PatientExamValidationResponse> => {
  const response = await apiClient.post(
    `${API_URL}/validation/patient-exam`,
    request,
  );
  return response.data;
};

const validationService = {
  validatePatientExam,
};

export default validationService;
